import { Currency } from '../../index.js';
import { z } from 'zod/v4';
const BILLING_SELECTOR_SPLIT = ':-:';
export const stringToBillingSelector = (billingSelector) => {
    const [billingAppendixId, creditorId, currency, isAdjustment, caseId, billAfter, caseEnded, billingPrevented,] = billingSelector.split(BILLING_SELECTOR_SPLIT);
    return {
        billingAppendixId,
        creditorId,
        currency: currency,
        isAdjustment: JSON.parse(isAdjustment),
        caseId: caseId || undefined,
        billAfter: billAfter || undefined,
        caseEnded: caseEnded == 'true' ? true : caseEnded == 'false' ? false : null,
        billingPrevented: billingPrevented == 'true'
            ? true
            : billingPrevented == 'false'
                ? false
                : null,
    };
};
export const billingSelectorToString = (billingSelector) => `${billingSelector.billingAppendixId}${BILLING_SELECTOR_SPLIT}${billingSelector.creditorId}${BILLING_SELECTOR_SPLIT}${billingSelector.currency}${BILLING_SELECTOR_SPLIT}${billingSelector.isAdjustment}${BILLING_SELECTOR_SPLIT}${billingSelector.caseId || ''}${BILLING_SELECTOR_SPLIT}${billingSelector.billAfter || ''}${BILLING_SELECTOR_SPLIT}${billingSelector.caseEnded}${BILLING_SELECTOR_SPLIT}${billingSelector.billingPrevented}`;
export const BillingSelectorSchema = z.object({
    creditorId: z.uuid(),
    currency: z.enum(Currency),
    isAdjustment: z.boolean(),
    billingAppendixId: z.uuid(),
    caseId: z.uuid().nullish(),
    billAfter: z.string().nullish(),
    caseEnded: z.boolean().nullish(),
    billingPrevented: z.boolean().nullish(),
});
export const CreateBillingCollectionSchema = z.object({
    newBillings: z.array(BillingSelectorSchema.and(z.object({
        billingVoucherIds: z.array(z.uuid()).optional(),
    }))),
});
export const getBillingName = (billing) => `${billing.handle} ${billing.id || 'X'}`;
export var AccountSettingLabel;
(function (AccountSettingLabel) {
    AccountSettingLabel["BankOrPSP"] = "BANK_OR_PSP";
    AccountSettingLabel["CreditorReferenceId"] = "CREDITOR_REFERENCE_ID";
})(AccountSettingLabel || (AccountSettingLabel = {}));
//# sourceMappingURL=index.js.map